export const VOLUNTEER_APPLY_REQUEST = "VOLUNTEER_APPLY_REQUEST";
export const VOLUNTEER_APPLY_SUCCESS = "VOLUNTEER_APPLY_SUCCESS";
export const VOLUNTEER_APPLY_FAIL = "VOLUNTEER_APPLY_FAIL";
export const VOLUNTEER_APPLY_RESET = "VOLUNTEER_APPLY_RESET";
